import { render, staticRenderFns } from "./FileButton.vue?vue&type=template&id=145a56db&"
import script from "./FileButton.vue?vue&type=script&lang=ts&"
export * from "./FileButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports